<template>
  <v-container fluid class="motorista-page pa-8 pt-12">
    
    <div class="motorista-header">
      <div>
        <h1 class="motorista-title">Motoristas</h1>
        <p class="motorista-subtitle">
          Controle os motoristas da sua transportadora, gerencie suas informações e status de atividade.
        </p>
      </div>
      <v-btn class="motorista-new-btn ml-0" depressed @click="novoMotorista()">
        <v-icon left size="18">mdi-plus</v-icon>
        Novo Motorista
      </v-btn>
    </div>

    <!-- Tabela -->
    <v-card class="motorista-table-card mt-6" outlined>
      <v-data-table
        class="motorista-table"
        :headers="headers"
        :items="usuarios"
        :loading="loading"
        loading-text="Carregando motoristas..."
        no-data-text="Nenhum motorista cadastrado"
        no-results-text="Nenhum resultado encontrado. Por favor, tente outra pesquisa."
        :items-per-page="8"
        :footer-props="{
          itemsPerPageText: 'Itens por Página',
          itemsPerPageOptions: [10, 15, 20],
          pageText: '{0}-{1} de {2}'
        }"
      >
        <template v-slot:[`item.status`]="{ item }">
          <span class="motorista-status" :class="item.status == 'Ativo' ? 'is-active' : 'error--text'">
            {{ item.status }}
          </span>
        </template>


        <template v-slot:[`item.aso`]="{ item }">
          <span
            class="motorista-data"
            :class="estaVencido(item.aso) ? 'is-vencido' : 'is-active'"
          >
            <span @click="abrirDialogDocumento('aso', item)">
              {{ item.aso }}
            </span>
            <v-icon
              class="ml-3"
              size="18"
              @click.stop="baixarDocumento('aso', item)"
            >
              mdi-download
            </v-icon>
          </span>
        </template>
        <template v-slot:[`item.toxicologico`]="{ item }">
          <span
            class="motorista-data"
            :class="estaVencido(item.toxicologico) ? 'is-vencido' : 'is-active'"
          >
            <span @click="abrirDialogDocumento('toxicologico', item)">
              {{ item.toxicologico }}
            </span>
            <v-icon
              class="ml-3"
              size="18"
              @click.stop="baixarDocumento('toxicologico', item)"
            >
              mdi-download
            </v-icon>
          </span>
        </template>
        <template v-slot:[`item.cnh`]="{ item }">
          <span
            class="motorista-data"
            :class="estaVencido(item.cnh) ? 'is-vencido' : 'is-active'"
          >
            <span @click="abrirDialogDocumento('cnh', item)">
              {{ item.cnh }}
            </span>
            <v-icon
              class="ml-3"
              size="18"
              @click.stop="baixarDocumento('cnh', item)"
            >
              mdi-download
            </v-icon>
          </span>
        </template>

        <template v-slot:[`item.acoes`]="{ item }">
          <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                class="motorista-actions"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon :color="accentColor">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense class="motorista-actions__menu">
              <v-list-item @click="editarMotorista(item)">
                <v-list-item-icon>
                  <v-icon :color="accentColor" size="18">mdi-pencil-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Editar</v-list-item-title>
              </v-list-item>

              <v-divider />

              <v-list-item @click="mudarStatus(item)">
                <v-list-item-icon>
                  <v-icon :color="item.status == 'Ativo' ? 'error' : accentColor" size="18">
                    {{ item.status ? 'mdi-account-off-outline' : 'mdi-account-check-outline' }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ item.status == 'Ativo' ? 'Inativar' : 'Ativar' }}
                </v-list-item-title>
              </v-list-item>

              <v-divider />

              <v-list-item @click="abrirDetalhesMotorista(item)">
                <v-list-item-icon>
                  <v-icon :color="accentColor" size="18">mdi-account-details</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Dados do Motorista</v-list-item-title>
              </v-list-item>

              <v-divider />

              <v-list-item @click="abrirDialogDocumento('aso', item)">
                <v-list-item-icon>
                  <v-icon :color="accentColor" size="18">mdi-clipboard-edit-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>ASO</v-list-item-title>
              </v-list-item>

              <v-divider />

              <v-list-item @click="abrirDialogDocumento('toxicologico', item)">
                <v-list-item-icon>
                  <v-icon :color="accentColor" size="18">mdi-vote</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Exame Toxicológico</v-list-item-title>
              </v-list-item>

              <v-divider />

              <v-list-item @click="abrirDialogDocumento('cnh', item)">
                <v-list-item-icon>
                  <v-icon :color="accentColor" size="18">mdi-card-account-details</v-icon>
                </v-list-item-icon>
                <v-list-item-title>CNH</v-list-item-title>
              </v-list-item>

              <v-divider />

              <v-list-item @click="abrirExclusao(item)">
                <v-list-item-icon>
                  <v-icon color="error" size="18">mdi-delete-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Excluir</v-list-item-title>
              </v-list-item>

            </v-list>
          </v-menu>
        </template>

      </v-data-table>
    </v-card>


    <!-- Dialog Cadastro -->
    <v-dialog v-model="dialogOpen" max-width="600" persistent scrollable>
      <v-card class="motorista-dialog" outlined>
        <v-card-title class="motorista-dialog__title">
          <span>{{ dialogTitle }}</span>
          <v-spacer />
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-6 pb-0">
          <div class="body-card-formulario">
            <v-alert type="info" outlined class="mb-6">
              Informe o <strong>WhatsApp</strong> para identificar o motorista no chatbot.
            </v-alert>
            <v-form ref="motoristaForm" v-model="formValid" lazy-validation>
              <v-container class="pa-0" fluid>
                <!-- Seção: Dados Básicos -->
                <div class="motorista-section-title mt-0">Dados Básicos</div>
                <v-divider class="mb-4" />

                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.nome"
                      label="Nome"
                      :rules="[rules.required]"
                      required
                      dense
                      outlined
                    />
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      :value="form.whatsapp"
                      label="WhatsApp"
                      @input="onWhatsappInput"
                      :rules="[rules.required]"
                      required
                      dense
                      outlined
                    />
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      :value="form.cpf"
                      label="CPF"
                      @input="onCpfInput"
                      dense
                      outlined
                    />
                  </v-col>
                </v-row>

                <!-- Seção: Endereço -->
                <div class="motorista-section-title mt-6">Endereço</div>
                <v-divider class="mb-4" />

                <v-row dense>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="form.cep"
                      label="CEP"
                      dense
                      outlined
                      :loading="loadingCep"
                      @blur="buscarCep"
                    />
                  </v-col>

                  <v-col cols="12" sm="8">
                    <v-text-field
                      v-model="form.rua"
                      label="Rua"
                      dense
                      outlined
                    />
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="form.numero"
                      label="Número"
                      dense
                      outlined
                    />
                  </v-col>

                  <v-col cols="12" sm="8">
                    <v-text-field
                      v-model="form.bairro"
                      label="Bairro"
                      dense
                      outlined
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="form.cidade"
                      label="Cidade"
                      dense
                      outlined
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="form.estado"
                      label="Estado"
                      dense
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-6">
          <v-spacer />
          <v-btn text @click="closeDialog">Cancelar</v-btn>
          <v-btn
            class="motorista-dialog__save"
            depressed
            :loading="saving"
            :disabled="saving"
            @click="saveMotorista"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Detalhes Motorista -->
    <v-dialog v-model="detalhesDialogOpen" max-width="600" scrollable>
      <v-card class="motorista-dialog" outlined>
        <v-card-title class="motorista-dialog__title">
          <span>Dados do Motorista</span>
          <v-spacer />
          <v-btn icon @click="detalhesDialogOpen = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-6 pb-4">
          <div class="body-card-formulario">
            <v-container class="pa-0" fluid>
              <v-row dense>
              <v-col cols="12">
                <div class="motorista-section-title mt-0">Dados Básicos</div>
                <v-divider class="mb-3" />
              </v-col>

              <v-col cols="6">
                <strong>Nome</strong>
                <div>{{ motoristaDetalhes?.nome || '-' }}</div>
              </v-col>

              <v-col cols="6">
                <strong>Status</strong>
                <div class="motorista-status" :class="motoristaDetalhes?.status == 'ATIVO' ? 'is-active' : 'error--text'">{{ motoristaDetalhes?.status === 'ATIVO' ? 'Ativo' : 'Inativo' }}</div>
              </v-col>

              <v-col cols="6">
                <strong>WhatsApp</strong>
                <div>{{ formatWhatsapp(motoristaDetalhes?.whatsapp || '') || '-' }}</div>
              </v-col>

              <v-col cols="6">
                <strong>CPF</strong>
                <div>{{ formatCpf(motoristaDetalhes?.cpf || '') || '-' }}</div>
              </v-col>

              

              <v-col cols="12" class="mt-4">
                <div class="motorista-section-title">Endereço</div>
                <v-divider class="mb-3" />
              </v-col>

              <v-col cols="4">
                <strong>CEP</strong>
                <div>{{ motoristaDetalhes?.cep || '-' }}</div>
              </v-col>

              <v-col cols="8">
                <strong>Rua</strong>
                <div>{{ motoristaDetalhes?.rua || '-' }}</div>
              </v-col>

              <v-col cols="4">
                <strong>Número</strong>
                <div>{{ motoristaDetalhes?.numero || '-' }}</div>
              </v-col>

              <v-col cols="8">
                <strong>Bairro</strong>
                <div>{{ motoristaDetalhes?.bairro || '-' }}</div>
              </v-col>

              <v-col cols="6">
                <strong>Cidade</strong>
                <div>{{ motoristaDetalhes?.cidade || '-' }}</div>
              </v-col>

              <v-col cols="6">
                <strong>Estado</strong>
                <div>{{ motoristaDetalhes?.estado || '-' }}</div>
              </v-col>

              <v-col cols="12" class="mt-4">
                <div class="motorista-section-title">Documentos</div>
                <v-divider class="mb-3" />
              </v-col>

              <v-col cols="4">
                <strong>ASO</strong>
                <div>
                  <span>{{ formatDate(motoristaDetalhes?.validade_aso) }}</span>
                  <v-btn
                    v-if="motoristaDetalhes?.caminho_aso"
                    text
                    small
                    class="ml-1 no-wrap"
                    @click="baixarDocumento('aso', motoristaDetalhes)"
                  >
                    <v-icon left small>mdi-download</v-icon>
                    Abrir
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="4">
                <strong>Toxicológico</strong>
                <div>
                  <span>{{ formatDate(motoristaDetalhes?.validade_toxicologico) }}</span>
                  <v-btn
                    v-if="motoristaDetalhes?.caminho_toxicologico"
                    text
                    small
                    class="ml-1 no-wrap"
                    @click="baixarDocumento('toxicologico', motoristaDetalhes)"
                  >
                    <v-icon left small>mdi-download</v-icon>
                    Abrir
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="4">
                <strong>CNH</strong>
                <div>
                  <span>{{ formatDate(motoristaDetalhes?.validade_cnh) }}</span>
                  <v-btn
                    v-if="motoristaDetalhes?.caminho_cnh"
                    text
                    small
                    class="ml-1 no-wrap"
                    @click="baixarDocumento('cnh', motoristaDetalhes)"
                  >
                    <v-icon left small>mdi-download</v-icon>
                    Abrir
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer />
          <v-btn text @click="detalhesDialogOpen = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Documento (ASO / Toxicológico / CNH) -->
    <v-dialog v-model="documentoDialogOpen" max-width="550" persistent>
      <v-card class="motorista-dialog" outlined>
        <v-card-title class="motorista-dialog__title">
          <span>{{ documentoDialogTitle }}</span>
          <v-spacer />
          <v-btn icon @click="fecharDialogDocumento">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-6 pb-0">
          <div class="body-card-formulario">
            <v-form ref="documentoFormRef" v-model="documentoFormValid" lazy-validation>
              <v-container class="pa-0" fluid>
                <div class="motorista-section-title mt-0">Anexar Documento</div>
                <v-divider class="mb-4" />

                <v-row dense>
                  <v-col cols="12">
                    <small v-if="documentoForm.caminhoAtual" class="grey--text">
                      Documento atual: {{ documentoForm.caminhoAtual }}
                    </small>
                  </v-col>

                  <v-col cols="12">
                    <v-file-input
                      v-model="documentoForm.arquivo"
                      label="Arquivo do documento (opcional)"
                      prepend-icon="mdi-paperclip"
                      accept=".pdf,image/*"
                      dense
                      outlined
                      show-size
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="documentoForm.validade"
                      label="Data de validade"
                      type="date"
                      :rules="[rules.required]"
                      dense
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer />
          <v-btn text :disabled="documentoSaving" @click="fecharDialogDocumento">Cancelar</v-btn>
          <v-btn
            class="motorista-dialog__save"
            depressed
            :loading="documentoSaving"
            :disabled="documentoSaving"
            @click="salvarDocumento"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Exclusao -->
    <v-dialog v-model="deleteDialogOpen" max-width="420" persistent>
      <v-card class="motorista-dialog" outlined>
        <v-card-title class="motorista-dialog__title">
          <span>Excluir Motorista</span>
          <v-spacer />
          <v-btn icon :disabled="deleting" @click="deleteDialogOpen = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-6 pb-2">
          <div class="motorista-confirmacao__texto">
            Tem certeza que deseja excluir o motorista <strong>{{ motoristaExclusao.nome || '-' }}</strong>?
          </div>
          <div class="motorista-confirmacao__aviso">
            Esta acao nao pode ser desfeita. Motoristas com viagens vinculadas devem ser inativados.
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer />
          <v-btn text :disabled="deleting" @click="deleteDialogOpen = false">Cancelar</v-btn>
          <v-btn
            class="motorista-dialog__delete"
            depressed
            :loading="deleting"
            :disabled="deleting"
            @click="confirmarExclusao"
          >
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import MotoristaServices from './motoristaServices';

  export default {
    name: 'listagemMotoristas',
  
    data() {
      return {
        dialogOpen: false,
        saving: false,
        formValid: false,
        accentColor: '#10b981',
        loadingCep: false,
        loading: false,
        usuarios: [],
        detalhesDialogOpen: false,
        motoristaDetalhes: null,
        documentoDialogOpen: false,
        documentoSaving: false,
        documentoFormValid: false,
        documentoTipo: null,
        deleting: false,
        deleteDialogOpen: false,
        motoristaExclusao: {},
        documentoForm: {
          motoristaId: null,
          validade: '',
          caminho: '',
          caminhoAtual: '',
          arquivo: null,
        },
        headers: [
          { text: 'NOME', value: 'nome', sortable: false },
          { text: 'STATUS', value: 'status', sortable: false },
          { text: 'WHATSAPP', value: 'whatsapp', sortable: false },
          { text: 'ASO', value: 'aso', sortable: false },
          { text: 'TOXICOLOGICO', value: 'toxicologico', sortable: false },
          { text: 'CNH', value: 'cnh', sortable: false },
          { text: 'AÇÕES', value: 'acoes', sortable: false, align: 'center' },
        ],
        form: {
          id: null,
          nome: '',
          whatsapp: '',
          cpf: '',
          rua: '',
          numero: '',
          bairro: '',
          cidade: '',
          estado: '',
          cep: ''
        },
        rules: {
          required: v => !!v || 'Campo obrigatório'
        }
      };
    },

    computed: {
      isEditMode() {
        return Boolean(this.form?.id);
      },

      dialogTitle() {
        return this.isEditMode ? 'Editar Motorista' : 'Novo Motorista';
      },

      documentoDialogTitle() {
        const mapa = {
          aso: 'ASO',
          toxicologico: 'Exame Toxicológico',
          cnh: 'CNH',
        };

        const label = mapa[this.documentoTipo] || 'Documento';
        return `Documento - ${label}`;
      },
    },

    mounted() {
      this.listarMotoristas();
    },

    methods:{
      estaVencido(data){
        if (!data || data === '-') return false;

        let date;

        if (typeof data === 'string') {
          if (data.includes('/')) {
            const partes = data.split('/');
            if (partes.length === 3) {
              const [dia, mes, ano] = partes.map(p => parseInt(p, 10));
              date = new Date(ano, (mes || 1) - 1, dia || 1);
            }
          } else {
            date = new Date(data);
          }
        } else {
          date = new Date(data);
        }

        if (!date || Number.isNaN(date.getTime())) {
          return false;
        }

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        return date < hoje;
      },

      onWhatsappInput(value) {
        this.form.whatsapp = this.formatWhatsapp(value);
      },

      onCpfInput(value) {
        this.form.cpf = this.formatCpf(value);
      },

      formatWhatsapp(value) {
        const digits = (value || '').replace(/\D/g, '').slice(0, 11);

        let result = '';

        if (digits.length > 0) {
          result = `(${digits.slice(0, 2)}`;
        }

        if (digits.length >= 3) {
          result += `) ${digits.slice(2, 7)}`;
        } else if (digits.length > 2) {
          result += `) ${digits.slice(2)}`;
        }

        if (digits.length > 7) {
          result += `-${digits.slice(7, 11)}`;
        }

        return result;
      },

      formatCpf(value) {
        const digits = (value || '').replace(/\D/g, '').slice(0, 11);

        let result = '';

        if (digits.length > 0) {
          result = digits.slice(0, 3);
        }
        if (digits.length >= 4) {
          result += `.${digits.slice(3, 6)}`;
        } else if (digits.length > 3) {
          result += `.${digits.slice(3)}`;
        }

        if (digits.length >= 7) {
          result += `.${digits.slice(6, 9)}`;
        } else if (digits.length > 6) {
          result += `.${digits.slice(6)}`;
        }

        if (digits.length >= 10) {
          result += `-${digits.slice(9, 11)}`;
        } else if (digits.length > 9) {
          result += `-${digits.slice(9)}`;
        }

        return result;
      },

      closeDialog() {
        if (this.saving) return;
        this.dialogOpen = false;
      },

      novoMotorista() {
        this.form = {
          id: null,
          nome: '',
          whatsapp: '',
          cpf: '',
          rua: '',
          numero: '',
          bairro: '',
          cidade: '',
          estado: '',
          cep: ''
        };
      
        this.formValid = false;
        this.dialogOpen = true;
      
        this.$nextTick(() => {
          this.$refs?.motoristaForm?.resetValidation?.();
        });
      },

      async buscarCep() {
        if (!this.form.cep) return;

        const cepLimpo = this.form.cep.replace(/\D/g, '');
        if (cepLimpo.length !== 8) {
          return;
        }

        this.loadingCep = true;
        try {
          const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
          const data = await response.json();

          if (data && !data.erro) {
            this.form.rua = data.logradouro || '';
            this.form.bairro = data.bairro || '';
            this.form.cidade = data.localidade || '';
            this.form.estado = data.uf || '';
          }
        } catch (error) {
          console.error('Erro ao buscar CEP:', error);
        } finally {
          this.loadingCep = false;
        }
      },

      formatDate(value) {
        if (!value) return '-';

        if (typeof value === 'string' && value.includes('/')) {
          return value;
        }

        const date = new Date(value);

        if (Number.isNaN(date.getTime())) {
          return value;
        }

        return date.toLocaleDateString('pt-BR');
      },

      normalizeMotorista(motorista) {
        const status = motorista && motorista.status === 'ATIVO' ? 'Ativo' : 'Inativo';

        return {
          id: motorista?.id,
          nome: motorista?.nome || '-',
          whatsapp: this.formatWhatsapp(motorista?.whatsapp || ''),
          status,
          aso: this.formatDate(motorista?.validade_aso),
          toxicologico: this.formatDate(motorista?.validade_toxicologico),
          cnh: this.formatDate(motorista?.validade_cnh),
          raw: motorista,
        };
      },

      async listarMotoristas() {
        try {
          this.loading = true;
          const response = await MotoristaServices.listar();
          const data = Array.isArray(response.data) ? response.data : [];
          this.usuarios = data.map(m => this.normalizeMotorista(m));
        } catch (error) {
          console.error('Erro ao listar motoristas:', error);
        } finally {
          this.loading = false;
        }
      },

      editarMotorista(item) {
        const raw = item?.raw || item || {};

        this.form = {
          id: raw.id || item.id || null,
          nome: raw.nome || item.nome || '',
          whatsapp: this.formatWhatsapp(raw.whatsapp || ''),
          cpf: raw.cpf || '',
          rua: raw.rua || '',
          numero: raw.numero || '',
          bairro: raw.bairro || '',
          cidade: raw.cidade || '',
          estado: raw.estado || '',
          cep: raw.cep || '',
        };

        this.formValid = true;
        this.dialogOpen = true;

        this.$nextTick(() => {
          this.$refs?.motoristaForm?.resetValidation?.();
        });
      },

      abrirDetalhesMotorista(item) {
        this.motoristaDetalhes = item?.raw || item || null;
        this.detalhesDialogOpen = true;
      },

      abrirExclusao(item) {
        this.motoristaExclusao = item || {};
        this.deleteDialogOpen = true;
      },

      baixarDocumento(tipo, item) {
        const raw = item?.raw || item || {};

        let caminho = null;
        if (tipo === 'aso') {
          caminho = raw.caminho_aso;
        } else if (tipo === 'toxicologico') {
          caminho = raw.caminho_toxicologico;
        } else if (tipo === 'cnh') {
          caminho = raw.caminho_cnh;
        }

        if (!caminho) {
          this.$toasted?.show('Nenhum arquivo encontrado para este documento.');
          return;
        }

        let url = caminho;

        // Se o backend salvou apenas o caminho relativo, tenta compor com a base da API
        if (!/^https?:\/\//i.test(caminho)) {
          const baseApi = process.env.VUE_APP_API_BASE_URL || '';
          const baseSemApi = baseApi.replace(/\/api\/?$/, '');
          url = `${baseSemApi}${caminho.startsWith('/') ? caminho : `/${caminho}`}`;
        }

        window.open(url, '_blank');
      },

      abrirDialogDocumento(tipo, item) {
        const raw = item?.raw || item || {};

        this.documentoTipo = tipo;
        this.documentoForm = {
          motoristaId: raw.id || item.id || null,
          validade:
            tipo === 'aso'
              ? raw.validade_aso || ''
              : tipo === 'toxicologico'
              ? raw.validade_toxicologico || ''
              : raw.validade_cnh || '',
          caminho:
            tipo === 'aso'
              ? raw.caminho_aso || ''
              : tipo === 'toxicologico'
              ? raw.caminho_toxicologico || ''
              : raw.caminho_cnh || '',
          caminhoAtual:
            tipo === 'aso'
              ? raw.caminho_aso || ''
              : tipo === 'toxicologico'
              ? raw.caminho_toxicologico || ''
              : raw.caminho_cnh || '',
          arquivo: null,
        };

        this.documentoFormValid = false;
        this.documentoDialogOpen = true;

        this.$nextTick(() => {
          this.$refs?.documentoFormRef?.resetValidation?.();
        });
      },

      fecharDialogDocumento() {
        if (this.documentoSaving) return;
        this.documentoDialogOpen = false;
      },

      async saveMotorista() {
        const isValid = this.$refs?.motoristaForm?.validate?.();
        if (!isValid) return;

        this.saving = true;

        try {
          const payload = {
            nome: this.form.nome,
            whatsapp: (this.form.whatsapp || '').replace(/\D/g, ''),
            cpf: (this.form.cpf || '').replace(/\D/g, '') || null,
            cep: this.form.cep || null,
            rua: this.form.rua || null,
            numero: this.form.numero || null,
            bairro: this.form.bairro || null,
            cidade: this.form.cidade || null,
            estado: this.form.estado || null,
          };

          if (this.isEditMode) {
            await MotoristaServices.atualizar(this.form.id, payload);
            this.$toasted?.show('Motorista atualizado com sucesso');
          } else {
            await MotoristaServices.criar(payload);
            this.$toasted?.show('Motorista criado com sucesso');
          }

          this.dialogOpen = false;
          await this.listarMotoristas();
        } catch (error) {
          console.error('Erro ao salvar motorista:', error);

          if (error?.response?.status === 409) {
            this.$toasted?.show('Já existe motorista cadastrado com este WhatsApp para esta transportadora.');
          } else {
            const mensagem = error?.response?.data?.error || 'Erro ao salvar motorista';
            this.$toasted?.show(mensagem);
          }
        } finally {
          this.saving = false;
        }
      },

      async salvarDocumento() {
        const isValid = this.$refs?.documentoFormRef?.validate?.();
        if (!isValid) return;

        if (!this.documentoTipo || !this.documentoForm.motoristaId) return;

        this.documentoSaving = true;

        try {
          // Se houver arquivo selecionado, envia via upload (multipart)
          if (this.documentoForm.arquivo) {
            const formData = new FormData();

            formData.append('arquivo', this.documentoForm.arquivo);
            formData.append('validade', this.documentoForm.validade || '');

            await MotoristaServices.uploadDocumento(
              this.documentoForm.motoristaId,
              this.documentoTipo,
              formData,
            );
          } else {
            const payload = {};

            if (this.documentoTipo === 'aso') {
              payload.validade_aso = this.documentoForm.validade || null;
              payload.caminho_aso = this.documentoForm.caminho || null;
            } else if (this.documentoTipo === 'toxicologico') {
              payload.validade_toxicologico = this.documentoForm.validade || null;
              payload.caminho_toxicologico = this.documentoForm.caminho || null;
            } else if (this.documentoTipo === 'cnh') {
              payload.validade_cnh = this.documentoForm.validade || null;
              payload.caminho_cnh = this.documentoForm.caminho || null;
            }

            await MotoristaServices.atualizar(this.documentoForm.motoristaId, payload);
          }
          this.$toasted?.show('Documento salvo com sucesso');

          this.documentoDialogOpen = false;
          await this.listarMotoristas();
        } catch (error) {
          console.error('Erro ao salvar documento do motorista:', error);
          const mensagem = error?.response?.data?.error || 'Erro ao salvar documento do motorista';
          this.$toasted?.show(mensagem);
        } finally {
          this.documentoSaving = false;
        }
      },

      async mudarStatus(item) {
        if (!item?.id) return;

        try {
          await MotoristaServices.mudarStatus(item.id);
          await this.listarMotoristas();
        } catch (error) {
          console.error('Erro ao mudar status do motorista:', error);
          if (error?.response?.status === 409) {
            this.$toasted?.show('Já existe motorista ATIVO com este WhatsApp para esta transportadora.');
          } else {
            const mensagem = error?.response?.data?.error || 'Erro ao mudar status do motorista';
            this.$toasted?.show(mensagem);
          }
        }
      },

      async confirmarExclusao() {
        if (!this.motoristaExclusao?.id) return;

        this.deleting = true;

        try {
          await MotoristaServices.excluir(this.motoristaExclusao.id);
          this.$toasted?.show('Motorista excluido com sucesso.');
          this.deleteDialogOpen = false;
          this.motoristaExclusao = {};
          await this.listarMotoristas();
        } catch (error) {
          console.error('Erro ao excluir motorista:', error);
          const mensagem = error?.response?.data?.error || 'Erro ao excluir motorista';
          this.$toasted?.show(mensagem);
        } finally {
          this.deleting = false;
        }
      },

    }

  }
</script>


<style scoped>
  @import "../../assets/inter-font.css";
  
  .motorista-page {
    font-family: "Inter", sans-serif;
  }
  
  .motorista-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }
  
  .motorista-title {
    color: #10b981;
    font-size: 22px;
    font-weight: 800;
    line-height: 1.2;
    margin: 0;
  }
  
  .motorista-subtitle {
    color: #7a8ca6;
    font-size: 13px;
    margin: 6px 0 0;
  }
  
  .motorista-new-btn {
    background-color: #10b981 !important;
    color: #ffffff !important;
    border-radius: 12px;
    text-transform: none;
    font-weight: 700;
    letter-spacing: 0.01em;
    padding: 10px 16px;
  }

  .documentacao-outlined-btn {
    color: #10b981 !important;
    border-radius: 12px;
    text-transform: none;
    font-weight: 700;
    letter-spacing: 0.01em;
    padding: 10px 10px;
  }
  
  .users-stat {
    border-radius: 16px;
    border-color: #e6ebf1 !important;
  }
  
  .users-stat__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 18px;
    gap: 12px;
  }
  
  .users-stat__label {
    color: #7a8ca6;
    font-weight: 600;
    font-size: 12px;
  }
  
  .users-stat__value {
    color: #1f2a44;
    font-weight: 800;
    font-size: 28px;
    margin-top: 6px;
  }
  
  .users-stat__value--accent {
    color: #10b981;
  }
  
  .users-stat__icon {
    width: 44px;
    height: 44px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .users-stat__icon--primary {
    background: rgba(122, 140, 166, 0.12);
  }
  
  .users-stat__icon--accent {
    background: rgba(16, 185, 129, 0.12);
  }
  
  
  .users-stat__icon--muted {
    background: rgba(122, 140, 166, 0.12);
  }
  
  .motorista-table-card {
    border-radius: 16px;
    border-color: #e6ebf1 !important;
  }
  
  .motorista-table {
    border-radius: 16px;
  }
  
  .motorista-table ::v-deep th {
    color: #7a8ca6 !important;
    font-weight: 800 !important;
    font-size: 11px !important;
    letter-spacing: 0.08em;
  }
  
  .motorista-table ::v-deep td {
    color: #1f2a44;
    font-size: 13px;
  }
  
  .motorista-table ::v-deep .v-data-table__wrapper {
    border-radius: 16px;
  }
  
  .motorista-status {
    font-weight: 800;
  }
  
  .motorista-status.is-active {
    color: #10b981;
  }
  
  .motorista-data {
    font-weight: 500;
    cursor: pointer;
  }

  .motorista-data:hover, .motorista-data.is-active:hover {
    color: #45e6b0;
  }
  
  .motorista-data.is-active {
    color: #10b981;
  }

  .motorista-data.is-vencido {
    color: #ef4444;
  }

  .motorista-data.is-vencido:hover {
    color: #dc2626;
  }
  
  .users-profile {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 800;
  }
  
  .motorista-actions {
    opacity: 0.9;
  }
  
  .motorista-actions__menu {
    min-width: 180px;
  }
  
  .motorista-dialog {
    border-radius: 16px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
  }
  
  .motorista-dialog__title {
    font-weight: 800;
    color: #10b981;
  }
  
  .motorista-dialog__save {
    background-color: #10b981 !important;
    color: #ffffff !important;
    border-radius: 12px;
    text-transform: none;
    font-weight: 800;
  }

  .motorista-dialog__delete {
    background-color: #ef4444 !important;
    color: #ffffff !important;
    border-radius: 12px;
    text-transform: none;
    font-weight: 800;
  }

  .motorista-confirmacao__texto {
    color: #1f2a44;
    font-size: 14px;
    line-height: 1.6;
  }

  .motorista-confirmacao__aviso {
    color: #7a8ca6;
    font-size: 13px;
    margin-top: 10px;
  }

  .motorista-section-title {
    font-weight: 600;
    font-size: 14px;
    color: #3a4b72;
  }

  .motorista-dialog .v-card-text {
    flex: 1 1 auto;
    overflow: hidden;
    max-height: 90vh;
  }

  .body-card-formulario {
    max-height: 100%;
    overflow-y: auto;
    padding-right: 4px;
  }
  
  .no-wrap {
    white-space: nowrap;
  }
</style>
